import React, { useState } from 'react';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import { FPActionButton } from 'UI/components/atoms';
import FPChip from 'UI/components/atoms/FPChip';
import { SvgArrowDown, SvgArrowUp } from 'UI/res';

import PreviewBulkMetaRows from '../../PreviewBulkMetaRows';

import { STEPS_STATUS_COLOR_BY_ID } from './PreviewMetaRowsSections.constants';
import { useMetaRowsSectionsStyles } from './PreviewMetaRowsSections.styled';

const {
  preview: { mailMeta: MAIL_META_STRINGS }
} = strings.bulkEmails;

export const PreviewMetaRowsSections = ({
  emailBody = null,
  firstSectionData,
  isEmailBodySectionAlwaysVisible = false,
  secondarySectionData,
  status,
  subject = ''
}) => {
  const classes = useMetaRowsSectionsStyles();
  const [shouldShowMoreData, setShouldShowMoreData] = useState(false);
  const shouldShowHtmlSection = emailBody && shouldShowMoreData;

  return (
    <Grid container item direction="column" className={classes.metaSection}>
      <Grid container item className={classes.subjectContainer} wrap="nowrap">
        <Typography variant="h6">{subject}</Typography>
        <FPChip
          className={classes.statusChip}
          color={STEPS_STATUS_COLOR_BY_ID[status?.id] || STEPS_STATUS_COLOR_BY_ID.default}
          label={status?.title}
          variant="outlined"
        />
      </Grid>
      <PreviewBulkMetaRows rowsToRender={firstSectionData} />
      <Grid item className={classes.buttonContainer}>
        <FPActionButton
          size="small"
          onClick={() => setShouldShowMoreData(!shouldShowMoreData)}
          text={strings.formatString(MAIL_META_STRINGS.showButton.text, {
            moreLess: shouldShowMoreData ? 'less' : 'more'
          })}
          variant="text"
          icon={shouldShowMoreData ? SvgArrowUp : SvgArrowDown}
          iconPosition="right"
          iconProps={{ size: 12 }}
        />
      </Grid>
      <Collapse in={secondarySectionData && shouldShowMoreData}>
        <PreviewBulkMetaRows rowsToRender={secondarySectionData} />
      </Collapse>
      <Collapse in={shouldShowHtmlSection || isEmailBodySectionAlwaysVisible}>
        <Divider />
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: emailBody }} className={classes.emailBody} />
      </Collapse>
    </Grid>
  );
};
